import { useState } from 'react';
import Modal from './Modal';
import AllUserProfilesResource from '../resources/AllUserProfiles';
import useCopy from '../util/useCopy';
import { Header } from './Header';
import ViewBallotModal from './ViewBallotModal';
import ComposeBallotModal from './ComposeBallotModal';
import { makeClassName } from '@siteless/util';
import BallotsCompletedResource from '../resources/Ballot/Completed';
import { CurrentUserMustResource } from '../resources/Auth/CurrentUserMust';
import { Virtuoso } from 'react-virtuoso';
import { UserListItem } from './UserListItem';

export let AllUsersModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  let copy = useCopy();
  let currentUser = CurrentUserMustResource.use();

  let [focusedBallotId, setFocusedBallotId] = useState<string | undefined>();
  let [isCurrentUserBallotFocused, setIsCurrentUserBallotFocused] =
    useState(false);

  let [allUserProfiles] = AllUserProfilesResource.useLoadable();
  let completed = BallotsCompletedResource.use();

  let usersIds = Object.entries(completed)
    .filter(([key, completed]) => Boolean(completed))
    .map(([key]) => key)
    .filter((userId) => allUserProfiles?.users?.[userId])
    .sort((a, b) => {
      if (a === currentUser.id) return -1;
      if (b === currentUser.id) return 1;

      let aCompleted = completed[a] || false;
      let bCompleted = completed[b] || false;

      if (aCompleted && !bCompleted) return -1;
      if (bCompleted && !aCompleted) return 1;

      return a.localeCompare(b);
    });

  let virtuosoData = [
    null, // padding top
    ...usersIds,
    null, // padding bottom
  ];

  let paddingTopIndexCorrectOffset = -1;

  return (
    <>
      <ComposeBallotModal
        isOpen={isCurrentUserBallotFocused}
        onClose={() => {
          setIsCurrentUserBallotFocused(false);
        }}
      />
      {focusedBallotId && (
        <ViewBallotModal
          ballotKey={focusedBallotId}
          isOpen
          onClose={() => {
            setFocusedBallotId(undefined);
          }}
        />
      )}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        disableBodyPadding
        className="LeagueModal flex"
      >
        <div className="relative flex h-full flex-col">
          <div className="flex-none bg-white">
            <Header className="mx-4 border-b-4 border-neutral-100 px-2 py-4">
              {copy.everyone}
            </Header>
          </div>
          <div className="min-h-0 flex-1 overflow-auto">
            <Virtuoso
              style={{ height: '100%' }}
              data={virtuosoData}
              itemContent={(index, userIdOrNull) => {
                if (userIdOrNull === null) return <div className="h-12" />;

                let user = allUserProfiles?.users?.[userIdOrNull];

                if (!user) return null;

                return (
                  <UserListItem
                    className={makeClassName(
                      'mx-auto w-min pb-8',
                      (index + paddingTopIndexCorrectOffset) % 2
                        ? 'left-12'
                        : 'right-12',
                    )}
                    user={user}
                    isComplete={completed[userIdOrNull]}
                    isCurrentUser={user.id === currentUser.id}
                    onClick={() => {
                      if (user.id === currentUser.id)
                        setIsCurrentUserBallotFocused(true);
                      else setFocusedBallotId(user.id);
                    }}
                  />
                );
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
